import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import {
  FormControl,
  Grid,
  InputAdornment,
  useTheme,
  Typography,
  useMediaQuery,
  Button,
} from "@mui/material";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { EmailSendFile } from "../Services/EmailSendDailogService";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { PreferencesContext } from "../PreferencesContext";
import { useContext, useState } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import "react-quill/dist/quill.snow.css";
import { BootstrapTooltip } from "./BootStrapToolTip";
import { PAGE_SIZE } from "../Services/common/const";
import { AlertType } from "../shared/Modal/AlertType";

interface IEmailConfiguration {
  isOpen: boolean;
  isCloseSendEmail: any;
  Id: any;
  reportName: string;
  pdfFileName: string;
  page: any;
  finalTotalAmount: any;
  userName: string;
  itemData: any;
}
interface IEmailForm {
  to: string;
  cc?: string;
  subject: string;
  emailcontent: any;
}


const parameters: any = {
  pageIndex: 1,
  pageSize: PAGE_SIZE,
  financialYearEndDate: "2022-07-01T00:00:00",
  financialYearStartDate: "2022-07-13T00:00:00",
  sortColumn: "",
  sortDirection: "",
  totalCount: "",
  maxAllowedBranches: "",
  searchValue: "",
};
const validationSchema = Yup.object().shape({
  // to: Yup.string().email("Invalid email address.").required("To is required."),
  to: Yup.string()
    .transform((originalValue, originalObject) => {
      return originalValue.replace(/\s/g, '').trim();
    })
    .test('is-valid-emails', 'Invalid email addresses.', function (value) {
      if (!value) {
        return true;
      }
      const emailAddresses = value.split(',');
      for (const email of emailAddresses) {
        if (!Yup.string().email().isValidSync(email)) {
          return false;
        }
      }
      return true;
    })
    .required("To is required."),
  cc: Yup.string().email("Invalid email address."),
  // subject: Yup.string().required("Subject is required."),
});

export const EmailDialog = (configureProps: IEmailConfiguration) => {
  const theme = useTheme();
  const toMials = configureProps.itemData.email + (configureProps.itemData.otherMail?.length > 0 ? ',' + configureProps.itemData.otherMail : '');
  const emailFormData: IEmailForm = {
    to: toMials,
    cc: "",
    subject: "",
    emailcontent: "",
  };

  const { userContext, updateUserContext } = useContext(PreferencesContext);
  const [isSubmitting, setSubmitting] = useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const [addCC, setAddCC] = useState(false);
  const [param, setParam] = useState(parameters);
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const handleClickaddCC = () => setAddCC(true);
  async function sendEmail(values: IEmailForm) {
    try {
      setSubmitting(true);
      const SaveSendData = {
        reportName: configureProps.reportName,
        reportType: "pdf",
        pdfFileName: configureProps.pdfFileName,
        ids: parseInt(configureProps.Id),
        page: configureProps.page,
        branchId: userContext.branchId.toString(),
        firmId: userContext.firmId.toString(),
        branchName: userContext.branchName,
        consumerId: userContext.consumerId.toString(),
        toEmail: values.to,
        ccEmail: values.cc,
        subjectEmail: values.subject,
        bodyEmail: values.emailcontent,
        // logoServerImage : logoServerImage,
        finalTotalAmount: configureProps.finalTotalAmount,
        companyName: userContext.firmName,
        userName: configureProps.userName,
        adminEmail: userContext.email,
        startDate: userContext.financialYearStartDate,
        endDate: userContext.financialYearEndDate,
        financialYear: userContext.financialYear,
        eWayBillId: configureProps?.itemData?.eWayBillId || 0,
        eWayBillNo: configureProps?.itemData?.eWayBillNo || '',
      };
      configureProps.isCloseSendEmail(false);
      const result: any = await EmailSendFile(SaveSendData);

      if (result) {
        setSubmitting(false);
        setAddCC(false);
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: result.message,
        });

      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: result.message,
        });
      }
    } catch (e: any) {
      setSubmitting(false);
      setAddCC(false);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: typeof e === 'string' ? e as string : e?.message as string,
        alertType: AlertType.Error,
      });
    }
  }

  //----------DO NOT DELETE ----------
  // async function fetchFirmList() {
  //   let params = new URLSearchParams();
  //   params.append("consumerId", userContext.consumerId.toString());
  //   params.append("pageIndex", param.pageIndex);
  //   params.append("pageSize", param.pageSize);
  //   params.append("sortColumn", param.sortColumn);
  //   params.append("sortDirection", param.sortDirection);
  //   params.append("searchValue", param.searchValue);
  //   const result: any = await GetFirmList(params);
  //   if (result && result.data.data) {
  //     let FirmInfo = result.data.data.firmCollection;
  //     let selectedLogo = FirmInfo.find((e) => e.firmId === userContext.firmId);
  //     setLogoServerImage(selectedLogo.logoServerName);

  //     //   setParam({...param, totalCount: dataCount });
  //   } else {
  //     console.log("Error");
  //   }
  // }
  const handleCloseEmailPopUp = () => {
    configureProps.isCloseSendEmail(false);
    setAddCC(false);
  };


  return (
    <>

      <Dialog
        fullScreen={fullScreen}
        open={configureProps.isOpen}
        onClose={handleCloseEmailPopUp}
        fullWidth
        maxWidth="sm"
      >
        <DialogActions
          sx={{
            borderBottom: "1px solid #ced4da",
            padding: "17px 24px 14px 24px"
          }}
        >
          <Grid container className="pdf-viwer-heading-main-container">
            <h4> Send {configureProps.page}</h4>
          </Grid>
        </DialogActions>
        <Formik
          enableReinitialize
          initialValues={emailFormData}
          onSubmit={(value: IEmailForm) => {
            sendEmail(value);
          }}
          validateOnMount
          initialTouched={{
            to: true,
            subject: true,
          }}
          validationSchema={validationSchema}
        >
          {(props) => {
            return (
              <Form
                onSubmit={(e) => {
                  props.handleSubmit(e);
                }}
              >
                <DialogContent >
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <FormControl
                        fullWidth
                        variant="outlined"
                      >
                        <TextField
                          id="to"
                          placeholder="To"
                          label="To"
                          fullWidth
                          size="small"
                          margin="dense"
                          value={props.values.to}
                          onChange={(e) => {
                            props.handleChange(e);
                          }}
                          multiline
                          minRows={2} // 👈 increases visible height
                          onBlur={props.handleBlur}
                          tabIndex={2}
                          inputProps={{ enterKeyHint: "next" }}
                          error={props.errors.to && props.touched.to ? true : false}
                          InputProps={{
                            sx: {
                              '& .MuiInputBase-inputMultiline': {
                                padding: '12px 16px',
                                overflowX: 'hidden',
                                resize: 'none',
                              },
                            },
                            endAdornment: (
                              <InputAdornment position="end">
                                <BootstrapTooltip
                                  title={"Email's shoul be comma seprated."}
                                >
                                  <label
                                    style={{
                                      fontSize: "18px",
                                      marginRight: addCC ? "0px" : '15px',
                                    }}
                                    aria-label="toggle CC visibility"
                                    onClick={handleClickaddCC}
                                  >
                                    {!addCC ? "cc" : null}
                                  </label>
                                </BootstrapTooltip>
                              </InputAdornment>
                            ),
                          }}
                        />
                        {props.touched.to && props.errors.to && (
                          <Typography
                            className={"validation-message text-input error"}
                            color="error"
                          >
                            {props.errors.to}
                          </Typography>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      {addCC && (
                        <FormControl
                          fullWidth
                          variant="outlined"
                        >
                          <TextField
                            id="cc"
                            size="small"
                            label="CC"
                            multiline
                            minRows={3} // 👈 increases visible height
                            maxRows={5} // optional limit
                            onChange={props.handleChange}
                            value={props.values.cc}
                            onBlur={props.handleBlur}
                            error={props.touched.cc && Boolean(props.errors.cc)}
                          />
                          {props.touched.cc && props.errors.cc && (
                            <Typography
                              className={
                                props.touched.cc && props.errors.cc
                                  ? "validation-message text-input error"
                                  : "validation-message text-input"
                              }
                              color="error"
                            >
                              {props.errors.cc}
                            </Typography>
                          )}
                        </FormControl>
                      )}
                    </Grid>
                  </Grid>
                  {/* //----------DO NOT DELETE ---------- */}
                  {/* <FormControl
                    sx={{ marginBottom: "10px" }}
                    fullWidth
                    variant="outlined"
                  >
                    <TextField
                      size="small"
                      id="subject"
                      label="Subject"
                      fullWidth
                      value={props.values.subject}
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      error={
                        props.touched.subject && Boolean(props.errors.subject)
                      }
                    />
                    {props.touched.subject && props.errors.subject && (
                      <Typography
                        className={
                          props.touched.subject && props.errors.subject
                            ? "validation-message text-input error"
                            : "validation-message text-input"
                        }
                        color="error"
                      >
                        {props.errors.subject}
                      </Typography>
                    )}
                  </FormControl>
                  <FormControl
                    sx={{ marginBottom: "10px" }}
                    fullWidth
                    variant="standard"
                  >
                    <FormLabel>Compose Email</FormLabel>
                    <ReactQuill
                      theme="snow"
                      value={props.values.emailcontent}
                      onChange={(e: any) => {
                        props.handleChange("emailcontent");
                      }}
                    />
                  </FormControl> */}
                </DialogContent>

                <DialogActions sx={{ padding: "0px 24px 20px 24px" }}>
                  <Button variant="outlined" onClick={handleCloseEmailPopUp}>
                    Cancel
                  </Button>
                  <LoadingButton
                    color="primary"
                    // sx={{ marginRight: "5px" }}
                    // loading={isSubmitting}
                    type="submit"
                    variant="contained"
                    className="send-email-send-button"
                  >
                    <SendRoundedIcon
                      style={{
                        rotate: "690deg",
                        marginRight: "3px",
                        marginBottom: "2px",
                      }}
                    />
                    <Typography sx={{ color: "#fff !important" }}>Send</Typography>
                  </LoadingButton>

                </DialogActions>
              </Form>
            );
          }}
        </Formik>
      </Dialog>
    </>
  );
};
